import Cart from './Cart'
import Contacts from './Contacts'
import Home from './Home'
import Hotel from './Hotel'
import OrderDetails from './OrderDetails'
import Personal from './Personal'
import RestaurantAndCafe from './RestaurantAndCafe'
import PublicOffer from './PublicOffer'
import PrivatePolicy from './ProvatePolicy'
import Feedback from './Feedback'

export {
  Cart,
  Contacts,
  Home,
  Hotel,
  OrderDetails,
  Personal,
  RestaurantAndCafe,
  PublicOffer,
  PrivatePolicy,
  Feedback
}



// WEBPACK FOOTER //
// ./src/features/index.js